import { makeAutoObservable, runInAction } from 'mobx'
import apiClient from '../utils/apiClient'
import logger from '../utils/logger'

class ProductStore {
  // Продукты партнера
  products = []
  partnership = null
  
  // Состояния загрузки
  isLoading = false
  error = null

  constructor() {
    makeAutoObservable(this)
  }

  // Получение продуктов партнера
  async fetchPartnerProducts() {
    runInAction(() => {
      this.isLoading = true
      this.error = null
    })

    try {
      const response = await apiClient.get('/partnerships/partner-products')
      
      runInAction(() => {
        this.products = response.data.products
        this.partnership = response.data.partnership
        this.isLoading = false
      })

      logger.log('Продукты партнера загружены:', response.data.count)
      return response.data

    } catch (error) {
      runInAction(() => {
        this.error = error.response?.data?.error || 'Ошибка при загрузке продуктов'
        this.isLoading = false
        this.products = []
        this.partnership = null
      })

      logger.error('Ошибка при загрузке продуктов партнера:', error)
      throw error
    }
  }

  // Получить продукт по ID
  getProductById(productId) {
    return this.products.find(product => product.id === productId)
  }

  // Очистка ошибок
  clearError() {
    runInAction(() => {
      this.error = null
    })
  }

  // Сброс состояния
  reset() {
    runInAction(() => {
      this.products = []
      this.partnership = null
      this.isLoading = false
      this.error = null
    })
  }

  // Геттеры
  get hasProducts() {
    return this.products.length > 0
  }

  get activeProducts() {
    return this.products.filter(product => product.is_active)
  }

  get partnerName() {
    return this.partnership?.manufacturer_name || null
  }

  get discountPercentage() {
    return this.partnership?.discount_percentage || 0
  }
}

const productStore = new ProductStore()
export default productStore 